module.exports = __webpack_public_path__ + "img/13200.664ef6f0.jpg";